import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    const storedEmail = sessionStorage.getItem("prefilled_email")
    if (storedEmail && this.hasInputTarget) {
      this.inputTarget.value = storedEmail
      sessionStorage.removeItem("prefilled_email")
    }
  }

  submit(event) {
    event.preventDefault()

    if (!this.hasInputTarget) return

    const email = this.inputTarget.value.trim()

    sessionStorage.setItem("prefilled_email", email)
    window.location.href = "/session/new"
  }
}
